import React from 'react';

const BackToNormal = () => {
    return <div className="back-to-normal">

    </div>
}

export default BackToNormal